var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errors"},[_c('div',{attrs:{"id":"payment-element"}}),_vm._v(" "),(_vm.errors.card)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.card_error))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }